import React, { useEffect, useState } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';

import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import './SMSSender.scss';
import Field from '../../Shared/Wizard/Field/Field';

function SMSSender(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const [updateTable, setUpdateTable] = useState(0);

    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);

    const handleSendSMS = () => {
        axios.post('/api/smssender/', {
            messages,
        }
        ,{
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            setUpdateTable(updateTable + 1);
            notifySuccess(t("smssender.toast.sent"));
            setMessages(response.data);
        });
    };

    const handleOnCancel = () =>{
        if(props.onCancel != undefined) {
            props.onCancel();
        }
        setMessage("");
        setMessages([]);
    }

    const handleOnHide = () =>{
        if(props.onHide != undefined) {
            props.onCancel();
        }
        setMessage("");
        setMessages([]);
    }

    useEffect(() => {
        if (props.recipients != undefined) {
            setMessages(props.recipients.map(r => {
                return {
                    number: r.number,
                    name: r.name,
                    text: !props.customMessages ? message : r.message,
                    status: ""
                };
            }));
        }
    }, [props.recipients]);

    useEffect(() => {
        if (props.recipients != undefined && !props.customMessages) {
            setMessages(props.recipients.map(r => {
                return {
                    number: r.number,
                    name: r.name,
                    text: message,
                    status: ""
                };
            }));
        }
    }, [message]);

    useEffect(() => {
        if (props.recipients != undefined && props.customMessages) {
            setMessages(props.recipients.map(r => {
                return {
                    number: r.number,
                    name: r.name,
                    text: r.message,
                    status: ""
                };
            }));
        }
    }, [props.customMessages]);

    return (
        <Modal show={props.show} onHide={handleOnHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("smssender.title_new")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!props.customMessages ?
                    <Field
                        type="textarea"
                        title={t("smssender.message")}
                        value={message}
                        onChange={value => setMessage(value)}
                    ></Field>
                : null}

                <Table striped>
                    <thead>
                        <tr>
                            <th>{t("smssender.recipient")}</th>
                            { props.customMessages ? <th>{t("smssender.message")}</th> : null}
                            <th>{t("smssender.status")}</th>
                        </tr>
                    </thead>
                    <tbody>
                    { messages != undefined ? messages.map((message, key) =>
                        <tr key={key}>
                            <td>{message["number"]} {message["name"]}</td>
                            { props.customMessages ? <td>{(message["text"] as String).split("\n").map((t, key) =>
                                <p key={key} style={{ margin: "0px" }}>{t == "" ? <span>&nbsp;</span> : t}</p>
                            )}</td> : null}
                            <td>{message["status"]}</td>
                        </tr>
                    ) : null }
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleOnCancel}>
                    {t("smssender.cancel")}
                </Button>
                <Button onClick={handleSendSMS}>
                    {t("smssender.send")}
                </Button>
            </Modal.Footer>
    </Modal>
    );
}

export default SMSSender;